<template>
  <div>
    <Loader
      v-if="isLoading"
    />
    <VStepper
      v-else
      :steps="[
        { label: trans('event.assessment_configs.settings'), id: 'settings' },
        { label: trans('event.assessment_configs.organize'), id: 'organize' },
      ]"
      :start-step="settingsViewOnly ? 1 : 0"
    >
      <template #settings="{ changeStep }">
        <AssessmentConfigCreateStepOneView
          :event="event"
          @change-step="changeStep"
        />
      </template>
      <template #organize="{ changeStep }">
        <AssessmentConfigCreateStepTwoView
          :event-id="eventId"
          @change-step="changeStep"
        />
      </template>
    </VStepper>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Loader from '@/employees/components/Loader'
import AssessmentConfigCreateStepOneView from '@/employees/components/AssessmentConfig/view/AssessmentConfigCreateStepOneView'
import AssessmentConfigCreateStepTwoView from '@/employees/components/AssessmentConfig/view/AssessmentConfigCreateStepTwoView'
export default {
  name: 'AssessmentConfigFlowView',
  components: {
    Loader,
    AssessmentConfigCreateStepOneView,
    AssessmentConfigCreateStepTwoView,
  },
  props: {
    eventId: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      isLoading: true,
      settingsViewOnly: false,
    }
  },
  computed: {
    ...mapState({
      event (state) {
        return state.events.events[this.eventId]
      },
    }),
  },
  created () {
    this.$store.dispatch('getEvent',
      {
        eventId: this.eventId,
        queryParams: {
          include: ['assessmentConfig', 'students', 'childEvents.students', 'childEvents.classrooms', 'childEvents.lecturers'],
        },
      })
      .then(() => {
        //* The assessment config can't be updated later on, once child events have being generated
        this.settingsViewOnly = !!this.event.childEvents && this.event.childEvents.length !== 0
      })
      .finally(() => { this.isLoading = false })
  },
}
</script>
